import { EditOutlined } from "@ant-design/icons";
import { PageHeader, Row, Col } from "antd";
import { useState } from "react";

import UserIcon from "../../static/icon/UserIcon";

import ActionModalName from "./ActionModalName";

import ActionModalPassword from "./ActionModalPassword";
import { useAuth } from "../../context/auth";
import { formatAdminRole } from "../../utils/formatter";
import { notification } from "antd";

const UserDetail = () => {
  const { accessToken, user, adminRole, loadUser } = useAuth();

  const [visibleName, setVisibleName] = useState(false);
  const [visiblePassword, setVisiblePassword] = useState(false);

  return (
    <>
      <div className="flex justify-between items-center mt-2">
        <PageHeader
          style={{ padding: 0, width: "100%" }}
          title={
            <span className="flex items-center mt-2">
              <UserIcon /> &nbsp;&nbsp;User Detail
            </span>
          }
        />
      </div>
      <div className="content">
        <div className="max-w-4xl m-auto pb-12 mt-4">
          <Row gutter={[24, 24]}>
            <Col span={18}>
              <div className="font-semibold">Name - Surname</div>
              <div className="mt-2">
                {user.firstName} {user.lastName}
              </div>
            </Col>
            <Col span={6}>
              <div
                className="hover:opacity-80 cursor-pointer font-semibold"
                style={{ color: "#247CB3" }}
                onClick={() => {
                  setVisibleName(true);
                }}
              >
                <span className="hover:opacity-80 cursor-pointer">
                  <EditOutlined style={{ marginBottom: "6px" }} />
                  &nbsp;&nbsp;Edit
                </span>
              </div>
              <div className="mt-2"></div>
            </Col>
            <Col span={24}>
              <div className="font-semibold">Email</div>
              <div className="mt-2">{user.email}</div>
              <div></div>
            </Col>
            <Col span={24}>
              <div className="font-semibold">Role</div>
              <div className="mt-2">
                {formatAdminRole(adminRole)}
              </div>
              <div></div>
            </Col>
            <Col span={24} style={{ borderTop: "1px solid #D0D0D0" }}></Col>
            <Col span={18}>
              <div className="font-semibold">Password</div>
              <div className="mt-2">********</div>
            </Col>
            <Col span={6}>
              <div
                className="hover:opacity-80 cursor-pointer font-semibold"
                style={{ color: "#247CB3" }}
                onClick={() => {
                  setVisiblePassword(true);
                }}
              >
                <span className="hover:opacity-80 cursor-pointer">
                  <EditOutlined style={{ marginBottom: "6px" }} />
                  &nbsp;&nbsp;Edit
                </span>
              </div>
              <div className="mt-2"></div>
            </Col>
            {adminRole === 'admin' && (
              <button type="button" onClick={async () => {
                const url = new URL('/api/pea', window.location);
                const res = await fetch(url, {
                  headers: { 'X-ACCESS-TOKEN': accessToken },
                });
                const { peaToken } = await res.json();
                notification["success"]({
                  message: (<>
                    <div>token: {peaToken.token}</div>
                    <div>tokenC: {peaToken.tokenC}</div>
                  </>),
                });
              }} className="hover:opacity-80 cursor-pointer font-semibold" style={{ color: "#247CB3" }}>See pea token</button>
            )}
          </Row>
        </div>
      </div>
      <ActionModalName
        onOk={() => {
          setVisibleName(false);
          loadUser(accessToken);
        }}
        visibleName={visibleName}
        onCancel={() => {
          setVisibleName(false);
        }}
      />

      <ActionModalPassword
        onOk={() => {
          setVisiblePassword(false);
        }}
        visiblePassword={visiblePassword}
        onCancel={() => {
          setVisiblePassword(false);
        }}
      />
    </>
  );
};

export default UserDetail;
